import React from "react";
import { PureComponent } from "react";
import {
  FormGroup,
  Table,
  Input,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  CustomInput
} from "reactstrap";
// import './SearchBar.css';
import OverlayLoading from "../Commons/OverlayLoading.jsx";
import { Link } from "react-router-dom";
import moment from "moment";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
class ArticleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  render() {
    return (
      <div>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            姓名
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.name}
            onChange={e => this.props.onTextInputChange(e, "name")}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            公開暱稱
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.pseudonym}
            onChange={e => this.props.onTextInputChange(e, "pseudonym")}
          />
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            郵箱
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.email}
            onChange={e => this.props.onTextInputChange(e, "email")}
          />
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            電話
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.phone}
            onChange={e => this.props.onTextInputChange(e, "phone")}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            當前密碼
          </label>
          <Input
            id="example-text-input"
            type="password"
            value={this.props.data.original_password}
            onChange={e => this.props.onTextInputChange(e, "original_password")}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            修改密碼
          </label>
          <Input
            id="example-text-input"
            type="password"
            value={this.props.data.new_password}
            onChange={e => this.props.onTextInputChange(e, "new_password")}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            確認密碼
          </label>
          <Input
            id="example-text-input"
            type="password"
            value={this.props.data.new_password_confirmation}
            onChange={e =>
              this.props.onTextInputChange(e, "new_password_confirmation")
            }
          />
        </FormGroup>
      </div>
    );
  }
}

export default ArticleForm;
